const formatDateChinese= (date:Date):string=>{ 
  if(!date) return "未知";
  const year = date.getFullYear();
  let month = (1 + date.getMonth()).toString().padStart(2, '0');
  let day = date.getDate().toString().padStart(2, '0');

  const formattedDate = `${year}年${month}月${day}日`;
  console.log(formattedDate); 
  return formattedDate
}

const stringToDate =(dateString :string) :Date =>{
  // 使用字符串构造函数创建 Date 对象
  const date = new Date(dateString);
  
  // 检查日期是否有效
  if (isNaN(date.getTime())) {
      throw new Error('Invalid date string');
  }
  
  return date;
}


export function formatDate(date: Date): string {
    return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    });
}


const formatTime= (date:Date):string=>{  
  let hours = date.getHours().toString().padStart(2, '0');
  let minutes = date.getMinutes().toString().padStart(2, '0');

  const formattedTime = `${hours}:${minutes}`; 
  return  formattedTime;
}


const formatDatetime = (input: Date | string | number): string => {
  const date = toValidDate(input);
  if (!date) return "未知";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

const getDateStr= (datetimeString:string):string=>{
  return datetimeString.split(' ')[0];
}

const getTimeStr= (datetimeString:string):string=>{
  return datetimeString.split(' ')[1];
}


export const DateUtil = {
  formatDate,
  formatDateChinese,
  formatDatetime,
  formatTime,
  getDateStr,
  getTimeStr,
  stringToDate
}

// Added a robust converter and widened formatter inputs to accept Date | string | number
const toValidDate = (input: Date | string | number | null | undefined): Date | null => {
  if (input === null || input === undefined) return null;
  if (input instanceof Date) {
    return isNaN(input.getTime()) ? null : input;
  }
  if (typeof input === 'number') {
    const ms = input < 1e12 ? input * 1000 : input; // 支持秒/毫秒时间戳
    const d = new Date(ms);
    return isNaN(d.getTime()) ? null : d;
  }
  if (typeof input === 'string') {
    const trimmed = input.trim();
    if (!trimmed) return null;
    if (/^\d+$/.test(trimmed)) {
      const num = Number(trimmed);
      const ms = num < 1e12 ? num * 1000 : num;
      const d = new Date(ms);
      return isNaN(d.getTime()) ? null : d;
    }
    // 先尝试原始字符串（兼容标准 ISO 字符串，如 2024-01-01T12:00:00+08:00 / Z）
    const native = new Date(trimmed);
    if (!isNaN(native.getTime())) return native;
    // 再进行 Safari 兼容：将 2024-01-01 12:00:00 形式转成可解析格式
    // 同时将 'T' 替换为空格并移除尾部时区（如果存在），以本地时间解析
    const withoutTZ = trimmed.replace('T', ' ').replace(/([+-]\d{2}:?\d{2}|Z)$/i, '');
    const normalized = withoutTZ.replace(/-/g, '/');
    const d = new Date(normalized);
    return isNaN(d.getTime()) ? null : d;
  }
  return null;
};

const safeFormatDateChinese = (input: Date | string | number): string => {
  const d = toValidDate(input);
  if (!d) return '未知';
  return formatDateChinese(d);
};

const safeFormatDate = (input: Date | string | number): string => {
  const d = toValidDate(input);
  if (!d) return '未知';
  return formatDate(d);
};

const safeFormatTime = (input: Date | string | number): string => {
  const d = toValidDate(input);
  if (!d) return '未知';
  return formatTime(d);
};

const safeFormatDatetime = (input: Date | string | number): string => {
  const d = toValidDate(input);
  if (!d) return '未知';
  return formatDatetime(d);
};

// 暴露宽类型输入的便捷方法，保持原导出不破坏，同时新增带宽输入的别名
export const DateFormat = {
  formatDate: safeFormatDate,
  formatDateChinese: safeFormatDateChinese,
  formatDatetime: safeFormatDatetime,
  formatTime: safeFormatTime,
};